import React from 'react';

const WhatsappIcon = () => {
  return (<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#ie19jokiwa)">
      <path d="m.43 21.618 1.495-5.453a10.484 10.484 0 0 1-1.41-5.26C.52 5.1 5.243.383 11.044.383c2.814 0 5.461 1.096 7.447 3.086a10.437 10.437 0 0 1 3.08 7.446c-.004 5.8-4.726 10.523-10.527 10.523h-.004c-1.762 0-3.494-.443-5.032-1.28L.43 21.617z" fill="url(#ch4gfgupcb)" />
      <path fillRule="evenodd" clipRule="evenodd" d="M8.319 6.342c-.207-.455-.421-.464-.615-.472-.159-.01-.34-.005-.524-.005-.18 0-.477.069-.726.34-.25.27-.954.932-.954 2.273 0 1.34.975 2.638 1.113 2.819.137.18 1.886 3.02 4.653 4.112 2.303.906 2.772.726 3.27.683.499-.043 1.612-.658 1.84-1.294.227-.636.227-1.181.158-1.293-.068-.112-.249-.18-.524-.318-.27-.137-1.611-.795-1.86-.885-.25-.09-.43-.137-.615.138-.18.27-.704.885-.864 1.065-.159.18-.317.206-.588.069-.27-.138-1.152-.426-2.192-1.354-.812-.722-1.357-1.615-1.516-1.886-.16-.27-.018-.421.12-.554.12-.12.27-.318.408-.477.138-.16.18-.271.27-.456.091-.18.048-.34-.02-.477-.06-.141-.59-1.486-.834-2.028z" fill="#fff" />
    </g>
    <defs>
      <linearGradient id="ch4gfgupcb" x1="11" y1="21.619" x2="11" y2=".381" gradientUnits="userSpaceOnUse">
        <stop stopColor="#20B038" />
        <stop offset="1" stopColor="#60D66A" />
      </linearGradient>
      <clipPath id="ie19jokiwa">
        <path fill="#fff" d="M0 0h22v22H0z" />
      </clipPath>
    </defs>
  </svg>
  )
}
export default WhatsappIcon;
